module.exports = require("firebaseui");